import { convertLabelMapToConfig, convertLabelUomMapToConfig, mergeConfig } from '../../../Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.SamplePreparation.PercentPassing`]: `Result`,
      [`${prefix}.SamplePreparation.SampleHistory`]: `Sample History`,
      [`${prefix}.SamplePreparation.PreparationMethod`]: `Preparation History`,
      [`${prefix}.SamplePreparation.MaterialDriedBy`]: `Material Dried By`,
      [`${prefix}.SamplePreparation.PreparationProcessingMethod`]: `Oversize Material Removed By`,
      [`${prefix}.SamplePreparation.GuardSieves[0]`]: `Guard Sieve 1`,
      [`${prefix}.SamplePreparation.OversizeSieve`]: `425 µm Sieve`,
      [`${prefix}.SamplePreparation.WashingSieve`]: `425 µm Washing Sieve`,
      [`${prefix}.SamplePreparation.SeparationSieve`]: `2.36 mm Sieve`,
      [`${prefix}.SamplePreparation.SampleOven`]: `Preparation Oven`,
      [`${prefix}.SamplePreparation.DryingTemperature`]: `Drying Temperature`,
      [`${prefix}.SamplePreparation.WashingMethod`]: `Washing Method`,
      [`${prefix}.SamplePreparation.MaterialConditionAsTested`]: `Material Condition As Tested`,
      [`${prefix}.SamplePreparation.AssociatedPercentagePassing.ExternalTest.Results.PercentagePassing_425_Sieve`]: `Result`,
      [`${prefix}.LiquidLimit.StartedAtDateTime`]: 'Curing Started',
      [`${prefix}.LiquidLimit.CompletedAtDateTime`]: 'Curing Finished',
      [`${prefix}.LiquidLimit.CuringDuration`]: 'Curing Time',
      [`${prefix}.LiquidLimit.SelectedTrialForShrinkage`]: 'Selected Trial For Shrinkage Moisture',
      [`${prefix}.LiquidLimit.TotalPlayOfCupCheck`]: 'Total side-to-side play of cup ≤ 3.0 mm',
      [`${prefix}.LiquidLimit.DepthOfWearCheck`]: 'Depth of wear in cup ≤ 0.2 mm',
      [`${prefix}.LiquidLimit.MaxHeightOfCupCheck`]: 'Maximum height of raised cup = 10 mm',
      [`${prefix}.LiquidLimit.GroovingToolWidthCheck`]: 'Grooving tool tip width ≤ 2.5 mm ',
      [`${prefix}.LiquidLimit.NumberOfBlows`]: 'Number Of Blows',
      [`${prefix}.LiquidLimit.LiquidLimit`]: 'Liquid Limit',
      [`${prefix}.LiquidLimit.DryingTemperature`]: `Drying Temperature`,

      [`${prefix}.LiquidLimit.Trials.Drops`]: 'Blows',
      [`${prefix}.LiquidLimit.Trials.Drops2`]: '',
      [`${prefix}.LiquidLimit.Trials.NumberOfDrops`]: 'Number of Blows',
      [`${prefix}.LiquidLimit.Trials.SuitableForShrinkage`]: 'Suitable For Shrinkage',
      [`${prefix}.LiquidLimit.Trials.ExcludedTrial`]: 'Exclude Trial',
      [`${prefix}.LiquidLimit.Trials.MoistureDetermination.DryingTray.DryMassReadings.DryingTime`]: 'Drying Time',
      [`${prefix}.LiquidLimit.Trials.MoistureDetermination.DryingTray.ContainerLabel`]: 'Tare ID',
      [`${prefix}.LiquidLimit.Trials.MoistureDetermination.DryingTray.ContainerMass`]: 'Tare Mass',
      [`${prefix}.LiquidLimit.Trials.MoistureDetermination.Results.MoistureContentPercent`]: 'Moisture Content',

      [`${prefix}.PlasticLimit.NonPlastic`]: 'Result cannot be obtained',
      [`${prefix}.PlasticLimit.RolledBy`]: 'Rolled By',
      [`${prefix}.PlasticLimit.Balance`]: 'Balance',
      [`${prefix}.PlasticLimit.Oven`]: 'Oven',
      [`${prefix}.PlasticLimit.DryMassBalance`]: 'Dry Mass Balance',
      [`${prefix}.PlasticLimit.MaterialSuitability`]: `Material Suitability`,
      [`${prefix}.PlasticLimit.DryingTemperature`]: `Drying Temperature`,

      [`${prefix}.LinearShrinkage.NotTested`]: `Not tested`,

      [`${prefix}.Results.PlasticLimit`]: 'Average Water Content',
      [`${prefix}.Results.PlasticLimitText`]: 'Plastic Limit',
      [`${prefix}.Results.ReportWeightedPlasticityIndex`]: 'Q252 Result',
      [`${prefix}.Results.LiquidLimitText`]: 'Liquid Limit',
      [`${prefix}.Results.WeightedPlasticityIndex`]: 'Weighted Plasticity Index',
      [`${prefix}.Results.WeightedPlasticityIndexText`]: 'Weighted Plasticity Index',
      [`${prefix}.Results.Sieve_0_425`]: 'Passing 425 µm Sieve',
      [`${prefix}.Results.PlasticityIndex`]: 'Plasticity Index',
      [`${prefix}.Results.PlasticityIndexText`]: 'Plasticity Index',
      [`${prefix}.Results.LiquidLimit`]: 'Liquid Limit',
      [`${prefix}.Results.LiquidLimitText`]: 'Liquid Limit',
      [`${prefix}.Results.LinearShrinkage`]: 'Linear Shrinkage',
      [`${prefix}.Results.LinearShrinkageText`]: 'Linear Shrinkage',
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.SamplePreparation.PercentPassing`]: '%',
      [`${prefix}.SamplePreparation.AssociatedPercentagePassing.ExternalTest.Results.PercentagePassing_425_Sieve`]: '%',
      [`${prefix}.LiquidLimit.Trials.MoistureDetermination.Results.MoistureContentPercent`]: '%',
      [`${prefix}.Results.PlasticLimitText`]: '%',
      [`${prefix}.Results.LiquidLimitText`]: '%',
      [`${prefix}.Results.PlasticLimit`]: '%',
      [`${prefix}.Results.LiquidLimit`]: '%',
      [`${prefix}.Results.PlasticityIndexText`]: '%',
      [`${prefix}.Results.PlasticityIndex`]: '%',
      [`${prefix}.Results.WeightedPlasticityIndexText`]: '%',
      [`${prefix}.Results.WeightedPlasticityIndex`]: '%',
      [`${prefix}.Results.Sieve_0_425`]: '%',
      [`${prefix}.LiquidLimit.LiquidLimit`]: '%',
      [`${prefix}.Results.LinearShrinkage`]: '%',
      [`${prefix}.Results.LinearShrinkageText`]: '%',
    })
  );

export default getLabelConfig;
